import { LabelModule } from "../label/label.module";
import { HelpTextModule } from "../help-text/help-text.module";
import { StatusModule } from "../status/status.module";
import { InputModule } from "./../input/input.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SliderComponent } from "./slider.component";
import { FormsModule } from "@angular/forms";

@NgModule({
	declarations: [SliderComponent],
	imports: [CommonModule, FormsModule, InputModule, StatusModule, HelpTextModule, LabelModule],
	exports: [SliderComponent]
})
export class SliderModule { }
